
import React, { useState } from 'react';
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import TFASettings from './tfaSettings';
import ChangePassword from './changePassword';
import ChangePattern from './changePattern';
import ProfileSettings from './profile';
import { useGetTFASettings } from './api/apiSecuritysettings';
import { useModalContext } from '../../contexts/ModalContext';

const Settings = () => {

    const { data: getTFAdata, isLoading } = useGetTFASettings();
    const { theme } = useModalContext();

    const [activeTab, setActiveTab] = useState('profile');
    const toggle = tab => {
        if (activeTab !== tab) setActiveTab(tab);
    }

    return (
        <>
            <div className='SettingsPageMain'>
                <h4 className="pb-2 mb-4">Security Settings</h4>
                <div className="ad_pg_bx bg-white p-2" style={{ minHeight: "70vh" }}>
                    <Nav tabs className='mb-4' style={{ background: theme ? '#000' : '#ffff' }}>
                        <NavItem className='flex-fill'>
                            <NavLink className={classnames({ active: activeTab === 'profile' })} onClick={() => { toggle('profile'); }}>Profile Settings</NavLink>
                        </NavItem>
                        <NavItem className='flex-fill'>
                            <NavLink className={classnames({ active: activeTab === 'ChangePassword' })} onClick={() => { toggle('ChangePassword'); }}>Change Password</NavLink>
                        </NavItem>
                        <NavItem className='flex-fill'>
                            <NavLink className={classnames({ active: activeTab === 'TFA' })} onClick={() => { toggle('TFA'); }}>Two Factor Authentication</NavLink>
                        </NavItem>
                        <NavItem className='flex-fill'>
                            <NavLink className={classnames({ active: activeTab === 'ChangePattern' })} onClick={() => { toggle('ChangePattern'); }}>Change  Pattern</NavLink>
                        </NavItem>
                    </Nav>
                    <TabContent activeTab={activeTab}>
                        <TabPane tabId="profile">
                            {activeTab === "profile" && <ProfileSettings />}
                        </TabPane>
                        <TabPane tabId="ChangePassword">
                            {activeTab === "ChangePassword" && <ChangePassword />}
                        </TabPane>
                        <TabPane tabId="TFA">
                            {activeTab === "TFA" && <TFASettings getTFAdata={getTFAdata} isLoading={isLoading} />}
                        </TabPane>
                        <TabPane tabId="ChangePattern">
                            {activeTab === "ChangePattern" && <ChangePattern />}
                        </TabPane>
                    </TabContent>
                </div>
            </div>
            :

        </>
    )
}

export default Settings;